import { useState } from 'react';
import { Calendar, ChevronDown, X } from 'lucide-react';

const QUICK_RANGES = [
  { key: 'today', label: 'اليوم', days: 0 },
  { key: 'yesterday', label: 'أمس', days: 1 },
  { key: '7d', label: '7 أيام', days: 6 },
  { key: '30d', label: '30 يوم', days: 29 },
  { key: 'month', label: 'هذا الشهر', type: 'month' },
  { key: 'last_month', label: 'الشهر الماضي', type: 'last_month' },
  { key: 'quarter', label: '3 أشهر', days: 89 },
  { key: 'year', label: 'هذا العام', type: 'year' },
  { key: 'custom', label: 'مخصص', type: 'custom' },
];

function getRange(key) {
  const now = new Date(Date.now() + 2 * 60 * 60 * 1000);
  const today = now.toISOString().split('T')[0];
  const fmt = d => d.toISOString().split('T')[0];

  if (key === 'today') return { from: today, to: today };
  if (key === 'yesterday') { const d = new Date(now - 86400000); const s = fmt(d); return { from: s, to: s }; }
  if (key === '7d') return { from: fmt(new Date(now - 6 * 86400000)), to: today };
  if (key === '30d') return { from: fmt(new Date(now - 29 * 86400000)), to: today };
  if (key === 'quarter') return { from: fmt(new Date(now - 89 * 86400000)), to: today };
  if (key === 'month') return { from: today.slice(0, 7) + '-01', to: today };
  if (key === 'last_month') {
    const m = new Date(now.getFullYear(), now.getMonth() - 1, 1);
    const mEnd = new Date(now.getFullYear(), now.getMonth(), 0);
    return { from: fmt(m), to: fmt(mEnd) };
  }
  if (key === 'year') return { from: today.slice(0, 4) + '-01-01', to: today };
  return { from: today.slice(0, 7) + '-01', to: today };
}

export default function ReportFiltersBar({ dateFrom, dateTo, onDateChange }) {
  const [active, setActive] = useState('month');
  const [showCustom, setShowCustom] = useState(false);

  const selectRange = (r) => {
    if (r.type === 'custom') { setActive('custom'); setShowCustom(true); return; }
    setShowCustom(false);
    setActive(r.key);
    const range = getRange(r.key);
    onDateChange(range.from, range.to);
  };

  return (
    <div className="bg-card border-b border-border px-4 py-2 space-y-2">
      {/* Quick range chips */}
      <div className="flex gap-1.5 overflow-x-auto no-scrollbar">
        {QUICK_RANGES.map(r => (
          <button key={r.key} onClick={() => selectRange(r)}
            className={`px-3 py-1 rounded-full text-xs font-semibold whitespace-nowrap flex-shrink-0 transition-all ${
              active === r.key ? 'bg-primary text-white' : 'bg-muted text-muted-foreground hover:bg-muted/70'
            }`}>
            {r.label}
          </button>
        ))}
      </div>

      {/* Custom date pickers */}
      {showCustom && (
        <div className="flex items-center gap-2">
          <Calendar className="w-4 h-4 text-muted-foreground flex-shrink-0" />
          <input type="date" value={dateFrom} onChange={e => onDateChange(e.target.value, dateTo)}
            className="flex-1 rounded-lg border border-border bg-background px-2 py-1 text-xs" />
          <span className="text-xs text-muted-foreground">←</span>
          <input type="date" value={dateTo} onChange={e => onDateChange(dateFrom, e.target.value)}
            className="flex-1 rounded-lg border border-border bg-background px-2 py-1 text-xs" />
          <button onClick={() => setShowCustom(false)} className="text-muted-foreground hover:text-foreground">
            <X className="w-4 h-4" />
          </button>
        </div>
      )}

      {/* Active period display */}
      {!showCustom && (
        <p className="text-xs text-muted-foreground">
          الفترة: <span className="font-semibold text-foreground">{dateFrom} → {dateTo}</span>
        </p>
      )}
    </div>
  );
}